import React, { FC } from 'react';
import cn from 'classnames';
import ErrorImage from 'assets/images/error.png';
import CheckImage from 'assets/images/check.png';
import styles from './SendSmsMessageResult.module.scss';

export interface SendMessageResultProps {
  message: string;
  success?: boolean;
}

const SendSmsMessageResult: FC<SendMessageResultProps> = ({ message, success }) => {
  if (!message) {
    return null;
  }

  return (
    <div className={cn({ [styles.message__success]: success, [styles.message__error]: !success })}>
      <img src={success ? CheckImage : ErrorImage} alt="Result img" />
      <span>{message}</span>
    </div>
  );
};

export default SendSmsMessageResult;
